"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");





class Element extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.root.querySelector(".swiftref-inputs-group");

        this.initSlots();


    }

    static get observedAttributes() {
        return [];
    }

    get label() {
        return this.getAttribute("label");
    }
    set label(label) {
        this.setAttribute("label", label);
    }

    initSlots () {
        const label = this.textContent.trim();
        if (label) {
            const labelElement = document.createElement("label");
            labelElement.className = "swiftref-inputs-group-label";
            labelElement.innerText = label;
            this.container.appendChild(labelElement);
        }
        const checkboxes = this.querySelectorAll("swiftref-checkbox");
        for (const checkbox of checkboxes) {
            this.container.appendChild(checkbox);
        }
        const radios = this.querySelectorAll("swiftref-radio-button");
        const fieldset = document.createElement("fieldset");
        for (const radio of radios) {
            fieldset.innerHTML += radio.shadowRoot.innerHTML;
            this.container.appendChild(fieldset);
        }
        const extraStyles = fieldset.querySelectorAll("style");
        for (let i = 1; i < extraStyles.length; i += 1) {
            const extraStyle = extraStyles[i];
            fieldset.removeChild(extraStyle);
        }
    }


    renderAttribute (name, value) {

    }


    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-inputs-group", Element);

module.exports = Element;
